import React, { } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CircleProgressBar = (props) => {
  return (
    <Box sx={{ flexGrow: 1, position: 'relative', display: 'inline-flex', justifyContent: 'space-around' }}>
      <CircularProgress
        variant="determinate"
        sx={{color: '#F5F7FF'}}
        size={'6vw'}
        thickness={6}        
        value={100}
      />
      <CircularProgress
        variant="determinate"
        disableShrink
        sx={{
          color: '#DB8829',
          position: 'absolute',
          left: 0
        }}
        size={'6vw'}
        thickness={6}
        value={props.circleVal}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary" sx={{'@media (min-width: 1636px)': {fontSize: '1.2rem'}}}>
          {`${Math.round(props.circleVal)}%`}
        </Typography>
      </Box>
    </Box>
  );
}


export default CircleProgressBar;